import React, { FC, memo, useCallback } from 'react';
import { useAppDispatch, useAppSelector } from 'app/config/storeConfig/hooks';
import { Drawer } from 'shared/ui/Drawer';
import { getZoneFormState } from '../model/selectors/getZoneFormState';
import { zoneFormDrawerActions } from '../model/slice/zoneFormDrawerSlice';
import { ZoneForm } from './ZoneForm';

export const ZoneFormDrawer: FC = memo(() => {
  const dispatch = useAppDispatch();

  const zoneFormState = useAppSelector(getZoneFormState);

  const closeZoneFormDrawer = useCallback((): void => {
    dispatch(zoneFormDrawerActions.setOpenZoneForm({ mode: null, zone: null }));
  }, [dispatch]);

  return (
    <Drawer width={500} open={Boolean(zoneFormState.mode)} onClose={closeZoneFormDrawer}>
      <ZoneForm zone={zoneFormState.zone} mode={zoneFormState.mode} handleClose={closeZoneFormDrawer} />
    </Drawer>
  );
});
